import React, { Component } from "react";
import { Row, Col, FormGroup, Radio } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Field,
  reduxForm,
  reset,
  submit,
  stopSubmit,
  setSubmitFailed,
} from "redux-form";
import moment from "moment-timezone";
import { showError, showSuccess } from "ReduxErrorBar";
import DayPicker, { DateUtils } from "react-day-picker";
import DatePicker from "react-datepicker";
import TimezonePicker from "react-timezone";
import Helmet from "react-helmet";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { fetchEvent } from "ActionsMessage";
import {
  fetchScheduleDates,
  dateRangeUpdate,
  patchEventDetails,
  updateDateProps,
} from "GeneralTabAction";
import { isEmpty } from "ActionsSpeakers";
import { updateUnsavedChanges } from "DashboardMenuAction";
import {
  DATE_FORMAT,
  DISPLAY_LOCAL_DATE_FORMAT,
  DEVELOPMENT_TYPE,
  maxLengthObjectFc,
} from "Constants";
import TimeZoneSelect from "./timezone-select.js";
import Features from "./features.js";
import SeoUrl from "./seourl-section";
import DateBlock from "./date-block.js";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
class EditEvent extends BaseComponent {
  constructor(props) {
    super(props);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDataChange = this.handleEndDataChange.bind(this);

    this.state = {
      showPicker: false,
      loading: false,
      dateError: "",
      hoverRange: undefined,
      timezone: props.timezone,
    };

    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
  }

  componentDidMount() {
    this.props.fetchEvent(this.props.session, true);
    this.props.fetchScheduleDates(this.props.session);
    MAXLENOBJ = maxLengthObjectFc(this.props.history);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.timezone !== this.props.timezone) {
      this.setState({ timezone: nextProps.timezone });
    }
  }

  submitSettings() {
    //Adding extra validation for date
    if (this.props.dateProps.from && this.props.dateProps.to)
      this.props.dispatch(submit("EditEventForm"));
    else {
      var errorMessage = "";
      if (!this.props.dateProps.from) {
        errorMessage = "Event start date is required";
      } else if (!this.props.dateProps.to) {
        errorMessage = "Event end date is required";
      }

      this.setState({ dateError: errorMessage });

      this.props.dispatch(setSubmitFailed("EditEventForm", "eventenddate"));
      this.props.dispatch(stopSubmit("EditEventForm", new Error(errorMessage)));

      setTimeout(() => {
        this.setState({ dateError: "" });
      }, 2000);
    }
    //this.props.handleSubmit();
  }

  isSelectingFirstDay(from, to, day) {
    const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  }

  handleDayClick(day) {
    //debugger;
    this.props.updateUnsavedChanges();

    const { from, to } = this.props.dateProps;
    /*if (from && to && day >= from && day <= to) {
      this.handleResetClick();
      return;
    }*/

    if (this.isSelectingFirstDay(from, to, day)) {
      if (day < new Date()) return;
      /*this.setState({
        from: day,
        to: null,
        enteredTo: null,
      });*/

      this.props.updateDateProps({
        ...this.props.dateProps,
        from: day,
        to: null,
        enteredTo: null,
      });
      this.props.change("eventstartdate", moment(day).format(DATE_FORMAT));
      this.props.change("eventenddate", "");

      /*var hoverRange=[];
      for (var i=1; i <= 6; i++ ) {
        var hoverDate=new Date(day);
        hoverDate.setDate(hoverDate.getDate()+1);
        hoverRange.push(hoverDate);
      }*/
      var hoverRangeEndDate = new Date(day);
      hoverRangeEndDate.setDate(hoverRangeEndDate.getDate() + 29);

      this.setState({ hoverRange: { from: day, to: hoverRangeEndDate } });
    } else {
      // debugger;
      /*this.setState({
        to: day,
        enteredTo: day,
      });*/
      var curDate = moment(day);
      var disableDate = moment(from).add(29, "days");

      if (curDate.isAfter(disableDate, "day")) {
        return;
      }
      this.props.updateDateProps({
        ...this.props.dateProps,
        to: day,
        enteredTo: day,
      });
      this.props.dateRangeUpdate({
        startDate: from,
        endDate: day,
        allDate: {},
      });

      this.props.change("eventstartdate", moment(from).format(DATE_FORMAT));
      this.props.change("eventenddate", moment(day).format(DATE_FORMAT));

      this.setState({ showPicker: false });
    }
  }

  handleDayMouseEnter(day) {
    const { from, to } = this.state;
    if (!this.isSelectingFirstDay(from, to, day)) {
      this.props.updateDateProps({ ...this.props.dateProps, enteredTo: day });
      /*this.setState({
        enteredTo: day,
      });*/
    }
  }

  handleResetClick() {
    this.props.updateDateProps({ from: null, to: null, enteredTo: null });
    //this.setState({from: null,to: null,enteredTo: null});
  }

  handleStartDateChange(date) {
    this.props.updateUnsavedChanges();
    this.props.dateRangeUpdate({ startDate: date, endDate: date, allDate: {} });
  }

  handleEndDataChange(date) {
    //debugger;
    this.props.updateUnsavedChanges();
    this.props.dateRangeUpdate({
      startDate: this.props.startDate,
      endDate: date,
      allDate: {},
    });
  }

  renderBlockList(startDate, endDate, allDate) {
    startDate = moment(startDate);
    endDate = moment(endDate);

    //Sorting date.
    allDate.sort(
      (a, b) =>
        new moment(a.scheduledate).format("YYYYMMDD") -
        new moment(b.scheduledate).format("YYYYMMDD")
    );

    var arr = [];
    var day = {};
    var n = endDate.diff(startDate, "days") + 1;
    for (var i = 1; i <= n; i++) {
      if (i !== 1) {
        day = moment(day).add(1, "days");
      } else {
        day = startDate;
      }
      var activeDate = _.find(allDate, {
        scheduledate: moment(day).format(DATE_FORMAT),
      });
      arr.push(<DateBlock key={i} day={day} activeDate={activeDate} />);
    }
    return arr;
  }

  handleEventName() {
    this.props.updateUnsavedChanges();
  }

  handleEventDesc() {
    this.props.updateUnsavedChanges();
  }
  handleCountry() {
    this.props.updateUnsavedChanges();
  }

  onPublishChange() {
    this.props.updateUnsavedChanges();
  }

  onPrivacyChange() {
    this.props.updateUnsavedChanges();
  }

  onListingChange() {
    this.props.updateUnsavedChanges();
  }

  onConvertedTimezoneChange() {
    this.props.updateUnsavedChanges();
  }

  toggleCalendar = () => {
    this.setState({ showPicker: !this.state.showPicker });
  };

  renderFieldTexts(field) {
    let charactersLeft = "";
    if (field.maxlength) {
      charactersLeft = field.maxlength - field.input.value.length;
    }

    var labelposition = field.labelposition;
    // debugger
    var formdiv = "";
    if (field.formdiv !== undefined && field.formdiv === "false") {
      formdiv = "";
    }
    var divClassName = `form-group row ${formdiv} ${
      field.meta.error ? "has-danger" : ""
    }`;
    divClassName = `${divClassName} ${field.bsClass ? field.bsClass : ""}`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    if (labelposition === LABEL_POSITION_TOP) {
      labelClasses = "control-label-top col-sm-12";
      inputClasses = "col-sm-12 col-sm-offset-0";
    }
    return (
      <div className={divClassName}>
        {field.label !== "" ? (
          <label className={labelClasses}>
            {field.label}
            <span className="label-mandatory">
              {field.mandatory === "true" ? "*" : ""}
            </span>
          </label>
        ) : null}
        <div className={inputClasses} style={{ position: "relative" }}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.error ? field.meta.error : ""}
          </div>
          {field.maxlength ? (
            <span className="char-left">
              {field.input.value.length}
              {" / "}
              {field.maxlength}
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }

  renderFieldRadio(field) {
    return (
      <div className="" style={{ display: "inline" }}>
        <label
          className="custom-container-radio"
          style={{ marginRight: "20px" }}
        >
          {field.label}
          <input {...field.input} type={field.type} />
          <span className="radiomark"></span>
        </label>
      </div>
    );
  }

  updatetimezone = (value) => {
    this.props.autofill("eventtimezone", value);
    this.setState({ timezone: value });
    this.props.updateUnsavedChanges();
  };

  render() {
    // debugger;
    const today = new Date();
    const { from, to, enteredTo } = this.props.dateProps;
    const { hoverRange } = this.state;
    const modifiers = { start: from, end: enteredTo, highlighted: hoverRange };
    var disableDates = new Date(this.props.dateProps.from); //new Date(new Date(this.props.dateProps.from.getDate()+6););
    if (disableDates) disableDates.setDate(disableDates.getDate() + 6);
    // const disabledDays = { before: this.props.dateProps.from, after:disableDates};
    const selectedDays = [from, { from, to: enteredTo }];

    var eventStartDate = this.props.startDate;
    var eventEndDate = this.props.endDate;

    //var isDisabled = false;
    var allDate = this.props.allDate;
    /*if(this.props.scheduledates.isEditable !== undefined){
    isDisabled = !this.props.scheduledates.isEditable;
  }*/

    var endDateColor = "#2676ea";

    if (this.props.displayEndDate === "Choose") {
      endDateColor = "#d43f3a";
    }

    var curTime = moment().tz(this.state.timezone);
    curTime = curTime.format("h:mm A");

    var { handleSubmit, pristine, submitting, invalid, submit } = this.props;

    return (
      <div>
        <form
          ref={"editevent"}
          onSubmit={handleSubmit(submit)}
          encType="multipart/form-data"
        >
          <div className="general-tab-warp">
            <div
              className="control-label-top"
              style={{ paddingBottom: 10, paddingTop: 8, fontWeight: 500 }}
            >
              {LocaleStrings.general_form_general_section}
            </div>
            <div className="general-info">
              <Field
                name="eventname"
                label={LocaleStrings.general_form_label_event_name}
                placeholder={
                  LocaleStrings.general_form_label_event_name_placeholder
                }
                type="text"
                component={this.renderFieldTexts}
                bsClass=""
                formdiv="false"
                labelposition={LABEL_POSITION_TOP}
                onChange={this.handleEventName.bind(this)}
                mandatory="true"
                maxlength={MAXLENOBJ.eventname ? MAXLENOBJ.eventname : ""}
              />
              {DEVELOPMENT_TYPE === "eventify" ? (
                <Field
                  name="eventdescription"
                  label={LocaleStrings.general_form_label_event_description}
                  placeholder={
                    LocaleStrings.general_form_label_event_description_placeholder
                  }
                  component={this.renderFieldTextarea}
                  labelposition={LABEL_POSITION_TOP}
                  onChange={this.handleEventDesc.bind(this)}
                  maxlength={
                    MAXLENOBJ.eventdescription ? MAXLENOBJ.eventdescription : ""
                  }
                />
              ) : (
                ""
              )}
              {DEVELOPMENT_TYPE === "eventify" ? (
                <Field
                  name="country"
                  label={LocaleStrings.general_form_label_event_venue}
                  placeholder={
                    LocaleStrings.general_form_label_event_venue_placeholder
                  }
                  type="text"
                  component={this.renderFieldTexts}
                  bsClass=""
                  formdiv="false"
                  labelposition={LABEL_POSITION_TOP}
                  onChange={this.handleCountry.bind(this)}
                  mandatory="true"
                  maxlength={MAXLENOBJ.country ? MAXLENOBJ.country : ""}
                />
              ) : (
                ""
              )}
            </div>
            {/* {DEVELOPMENT_TYPE === "eventify" ? (
              <div className="form-group row">
                <div className="col-md-12 mt-10">
                  <Field
                    name="published"
                    label={LocaleStrings.general_form_label_event_publish}
                    component={this.renderFieldCheckbox}
                    type="checkbox"
                    onChange={this.onPublishChange.bind(this)}
                  />
                </div>
              </div>
            ) : (
              ""
            )} */}
            <div
              className="control-label-top"
              style={{ paddingBottom: 10, paddingTop: 8, fontWeight: 500 }}
            >
              {LocaleStrings.general_form_privacy_seo_section}
            </div>
            {DEVELOPMENT_TYPE === "eventify" ? (
              <div className="general-info">
                <div className="form-group row">
                  {/* <div className="col-md-6">
                    <div>
                      <label className="control-label-top">
                        {LocaleStrings.general_form_label_event_privacy}
                      </label>
                    </div>

                    <Field
                      name="eventtype"
                      label={
                        LocaleStrings.general_form_label_event_privacy_option_public
                      }
                      component={this.renderFieldRadio}
                      type="radio"
                      value="public"
                      onChange={this.onPrivacyChange.bind(this)}
                    />

                    <Field
                      name="eventtype"
                      label={
                        LocaleStrings.general_form_label_event_privacy_option_private
                      }
                      component={this.renderFieldRadio}
                      type="radio"
                      value="private"
                      onChange={this.onPrivacyChange.bind(this)}
                    />
                  </div> */}

                  <div className="col-md-6">
                    <div>
                      <label className="control-label-top">
                        {LocaleStrings.general_form_label_listing_privacy}
                      </label>
                    </div>
                    <Field
                      name="policylisting"
                      label={
                        LocaleStrings.general_form_label_event_listing_option1
                      }
                      component={this.renderFieldRadio}
                      type="radio"
                      value="listing"
                      onChange={this.onListingChange.bind(this)}
                    />

                    <Field
                      name="policylisting"
                      label={
                        LocaleStrings.general_form_label_event_listing_option2
                      }
                      component={this.renderFieldRadio}
                      type="radio"
                      value="unlisting"
                      onChange={this.onListingChange.bind(this)}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-12">
                    <SeoUrl />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </form>
        <Helmet>
          <style>{`
              .Range .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .Range .DayPicker-Day {
                border-radius: 0 !important;
              }
              .DayPicker {
                width:560px;
                display: block;
                font-size: 1.5rem;
                position: absolute;
                background: white;
                z-index: 1000;
                margin-top: 30px;
                border-radius: 10px;
                -webkit-box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
                box-shadow: 0 1px 15px 1px rgba(40,72,229,.2)!important;
              }
              .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
              }
              .Selectable .DayPicker-Day {
                border-radius: 0 !important;
              }
              .Selectable .DayPicker-Day--start {
                border-top-left-radius: 50% !important;
                border-bottom-left-radius: 50% !important;
              }
              .Selectable .DayPicker-Day--end {
                border-top-right-radius: 50% !important;
                border-bottom-right-radius: 50% !important;
              }
              .DayPicker-Day--highlighted{
                color:#4da1ff;
                font-weight:bold;

              }
          `}</style>
        </Helmet>
      </div>
    );
  }
}
function mapStateToProps(state) {
  var eventData = state.eventData[0];
  var published = false;

  if (eventData) {
    published = eventData.published;

    // if(eventData.policylisting == 1) {
    //   eventData.policylisting = "1";
    // }
    // else {
    //   eventData.policylisting = "0";
    // }
  }

  var startDate = moment().add(1, "days");
  if (eventData && eventData.eventstartdate)
    startDate = eventData.eventstartdate;

  var endDate = moment().add(6, "days");
  if (eventData && eventData.eventenddate) endDate = eventData.eventenddate;

  var displayStartDate = moment(state.dateProps.from).format(
    DISPLAY_LOCAL_DATE_FORMAT
  );
  var displayEndDate = "Choose";
  if (state.dateProps.to)
    displayEndDate = moment(state.dateProps.to).format(
      DISPLAY_LOCAL_DATE_FORMAT
    );

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  var timezone = null;
  if (eventData && eventData.eventtimezone) timezone = eventData.eventtimezone;

  if (!timezone) {
    eventData = { ...eventData, eventtimezone: tz };
    timezone = tz;
  }

  return {
    session: state.session,
    initialValues: eventData,
    scheduledates: state.scheduledates,
    allDate: state.updateScheduleDates,
    startDate,
    endDate,
    dateProps: state.dateProps,
    displayStartDate,
    displayEndDate,
    published,
    timezone,
  };
}

function validate(values) {
  var errors = {};
  if (
    (values["eventname"] && values["eventname"].trim() === "") ||
    values["eventname"] === ""
  ) {
    errors["eventname"] = LocaleStrings.general_form_label_event_name_error1;
  }

  if (values["eventname"] && MAXLENOBJ) {
    if (values["eventname"].length > MAXLENOBJ.eventname) {
      errors["eventname"] = "Max character length is: " + MAXLENOBJ.eventname;
    }
  }

  if (values["eventdescription"] && MAXLENOBJ) {
    if (values["eventdescription"].length > MAXLENOBJ.eventdescription) {
      errors["eventdescription"] =
        "Max character length is: " + MAXLENOBJ.eventdescription;
    }
  }

  if (values["country"] && MAXLENOBJ) {
    if (values["country"].length > MAXLENOBJ.country) {
      errors["country"] = "Max character length is: " + MAXLENOBJ.country;
    }
  }

  if (
    (values["country"] && values["country"].trim() === "") ||
    values["country"] === ""
  ) {
    errors["country"] = LocaleStrings.general_form_label_event_venue_error1;
  }

  return errors;
}

function onFormSubmit(values, dispatch, props) {
  var {
    eventname,
    country,
    eventdescription,
    eventid,
    eventstartdate,
    eventenddate,
    eventtype,
    eventtimezone,
    showconvertedtimezone,
    policylisting,
    published,
  } = values;
  values = {
    eventname,
    country,
    eventdescription,
    eventid,
    eventstartdate,
    eventenddate,
    eventtype,
    eventtimezone,
    showconvertedtimezone,
    policylisting,
    published,
    allDate: props.allDate,
  };
  props.submitSettingsHandler(values);
}

export default connect(
  mapStateToProps,
  {
    fetchEvent,
    updateUnsavedChanges,
    updateDateProps,
    fetchScheduleDates,
    dateRangeUpdate,
    patchEventDetails,
    showError,
    showSuccess,
  },
  null,
  { forwardRef: true }
)(
  reduxForm({
    validate,
    form: "EditEventForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(EditEvent)
);
